import { BrowserRouter } from "react-router-dom";
import Routes from "./routes/Routes";
import ThemeProvider from "./theme";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import "./css/App.css";
function App() {
  useEffect(() => {
    // Add protection against developer tools
    const protectAgainstDevTools = () => {
      // Detect if developer tools are open
      const devToolsOpen = () => {
        const widthThreshold = window.outerWidth - window.innerWidth > 160;
        const heightThreshold = window.outerHeight - window.innerHeight > 160;
        return widthThreshold || heightThreshold;
      };

      // Function to be called when dev tools are detected
      const handleDevToolsOpen = () => {
        // You can customize this action (e.g., redirect, show a message, etc.)
        alert("Developer tools are not allowed on this site.");
        window.location.href = "about:blank"; // Redirect to a blank page
      };

      // Check periodically
      setInterval(() => {
        if (devToolsOpen()) {
          handleDevToolsOpen();
        }
      }, 1000);

      // Disable right-click
      document.addEventListener("contextmenu", (e) => e.preventDefault());

      // Disable some keyboard shortcuts
      document.addEventListener("keydown", (e) => {
        if (
          // Ctrl+Shift+I (Windows) or Cmd+Option+I (Mac)
          (e.ctrlKey && e.shiftKey && e.keyCode === 73) ||
          (e.metaKey && e.altKey && e.keyCode === 73) ||
          // F12
          e.keyCode === 123
        ) {
          e.preventDefault();
        }
      });
    };

    protectAgainstDevTools();
    // return null;
  }, []);

  return (
    <BrowserRouter>
      <HelmetProvider>
        <ThemeProvider>
          <ScrollToTop />
          <Header />
          <Routes />
          <Footer />
        </ThemeProvider>
      </HelmetProvider>
    </BrowserRouter>
  );
}

export default App;
